var map = {
  "./da.json": [
    "91724",
    [
      47005
    ]
  ],
  "./fi.json": [
    "21262",
    [
      58211
    ]
  ],
  "./sv.json": [
    "34702",
    [
      16163
    ]
  ],
  "./ja.json": [
    "41210",
    [
      11719
    ]
  ],
  "./lt.json": [
    "68827",
    [
      18920
    ]
  ],
  "./sl.json": [
    "49604",
    [
      10405
    ]
  ],
  "./fr.json": [
    "70583",
    [
      56412
    ]
  ],
  "./es.json": [
    "6939",
    [
      86856
    ]
  ],
  "./no.json": [
    "21992",
    [
      3857
    ]
  ],
  "./cs.json": [
    "15821",
    [
      83870
    ]
  ],
  "./en.json": [
    "85484",
    [
      78621
    ]
  ],
  "./description/en.json": [
    "68203",
    [
      29208
    ]
  ],
  "./pl.json": [
    "2383",
    [
      93860
    ]
  ],
  "./hu.json": [
    "30348",
    [
      11325
    ]
  ],
  "./nl.json": [
    "80517",
    [
      44966
    ]
  ],
  "./de.json": [
    "52112",
    [
      81801
    ]
  ],
  "./pt.json": [
    "73821",
    [
      90652
    ]
  ],
  "./it.json": [
    "39730",
    [
      29327
    ]
  ],
  "./et.json": [
    "8326",
    [
      55435
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 75174;
module.exports = __rspack_async_context;
